
import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Trash2 } from "lucide-react";
import { Button } from "@/components/ui/button";

interface SaldoActionsProps {
  onClear: () => void;
  isSaving: boolean;
}

const SaldoActions: React.FC<SaldoActionsProps> = ({ onClear, isSaving }) => {
  return (
    <div className="mb-4">
      <div className="flex justify-between items-center mb-2">
        <Link to="/financeiro/contas" className="text-gray-500 text-xs hover:underline flex items-center">
          Gerenciar contas e extratos <ArrowRight className="h-3 w-3 ml-1" />
        </Link>
        <Button 
          variant="outline"
          size="sm"
          onClick={onClear}
          disabled={isSaving}
          className="text-gray-500 border-gray-200 hover:bg-gray-50 hover:text-gray-600 text-xs"
        >
          <Trash2 className="h-3 w-3 mr-1" /> Limpar
        </Button>
      </div>
    </div>
  );
};

export default SaldoActions;
